import { createAction, props } from '@ngrx/store';

export const deleteSurveyTask = createAction(
  '[SurveyTask/API] Delete SurveyTask',
  props<{ id: string }>(),
);

export const clearSurveyTasks = createAction(
  '[SurveyTask/API] Clear SurveyTasks',
);
